import * as React from 'react';
const InfluenzaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M92.14 57.24q.585-.225 1.17-.42s1.82-.86 6.68-1.54c11.71-1.62 23.89 1.78 30.05 12.39 3.8 6.25 5.52 13.76 4.9 21.07-.39 4.6-2.2 8.6-4.33 12.5M99.25 121.8c-4.34 3.2-9 5.77-14.14 7.27-3.58 1.04-8.09 2.09-11.54 0-1.5-.9-2.63-2.69-2.42-4.51.09-.79.43-1.53.52-2.32s-.09-1.39-.74-1.78c-.57-.34-1.12-.77-1.49-1.35s-.55-1.33-.35-2 .85-1.18 1.51-1.13c-.74-.12-1.45-.65-1.81-1.35s-.39-1.58-.08-2.31c.18-.42.45-.77.67-1.16s.39-.84.33-1.29-.32-.83-.75-.78c-.77-.37-1.56-.75-2.23-1.31-2.46-2.06-2.22-4.36-.42-6.86 1.42-1.97 2.96-4.09 3.58-6.46.7-2.67.24-5.51.33-8.22.18-5.32 2.33-10.68 5.46-15.34M86.13 128.92c2 5.56 4.38 10.98 7.12 16.19M107.58 95.6c.81-1.75 2.03-3.37 3.73-4.15 1.69-.79 3.9-.55 5.11.91.9 1.07 1.13 2.58 1.16 4.01.07 3.55-.94 7.12-2.85 10.05-.86 1.32-1.92 2.53-3.25 3.29-1.34.76-2.99 1.02-4.4.43"
      className="prefix__cls-2"
    />
    <path
      d="M111.35 99.91c-.36.94-.86 1.82-1.49 2.61-.03.03-.07.07-.11.05s.03-.09.03-.05"
      className="prefix__cls-2"
    />
    <path
      d="m91.61 67.29 3.65 6.02c.73 1.54.41 3.37-.8 4.57h0a4.03 4.03 0 0 1-5.71 0h0a4.045 4.045 0 0 1-.8-4.57l3.65-6.02ZM84.11 59.64l2.62 4.32a2.9 2.9 0 0 1-.57 3.28h0a2.89 2.89 0 0 1-4.09 0h0a2.9 2.9 0 0 1-.57-3.28l2.62-4.32ZM131.98 117.51h5.17M131.98 112h3.03M131.98 123.02h3.03M131.98 128.53h5.17M126.95 132.9a6.56 6.56 0 0 1 3.13 6.22c-.27 3.08-2.74 5.6-5.81 5.94a6.577 6.577 0 0 1-7.31-6.54c0-2.38 1.26-4.46 3.16-5.62v-21.6c0-1.89 1.53-3.42 3.42-3.42h0c1.89 0 3.42 1.53 3.42 3.42v21.6Z"
      className="prefix__cls-1"
    />
  </svg>
);
export default InfluenzaIcon;
